import Vue from 'vue';
import { mapState } from 'vuex';
export default Vue.extend({
    computed: {
        ...mapState('productModule', ['currentProduct', 'currentVariant']),
        product() {
            return this.currentProduct;
        },
        variantContent() {
            return (this.currentVariant?.content ?? {});
        },
        productContent() {
            return (this.product?.content ?? {});
        },
        productTabs() {
            return (this.product?.content_tabs ?? []);
        },
        // ---- DESCRIPTION SOURCE (variant first, then product) ----
        descriptionSource() {
            // const variantDescription = this.readLocalizedText(this.variantContent.description);
            // if (this.hasText(variantDescription)) return this.variantContent;
            return this.productContent;
        },
        shortDescription() {
            return this.readLocalizedText(this.descriptionSource.short_description);
        },
        longDescription() {
            return this.readLocalizedText(this.descriptionSource.description);
        },
        hasShortDescription() {
            return this.hasText(this.shortDescription);
        },
        hasLongDescription() {
            return this.hasText(this.longDescription);
        },
        hasAnyDescription() {
            return this.hasShortDescription || this.hasLongDescription;
        },
        // ---- HIGHLIGHTS (variant first, then product) ----
        highlights() {
            const variantHighlights = this.variantContent.highlights ?? null;
            const productHighlights = this.productContent.highlights ?? null;
            const pick = variantHighlights ?? productHighlights;
            if (!pick)
                return null;
            const isLocalized = typeof pick === 'object' &&
                pick !== null &&
                Object.prototype.hasOwnProperty.call(pick, 'en');
            const value = isLocalized ? pick.en : pick;
            if (value == null)
                return null;
            if (Array.isArray(value)) {
                const cleaned = value.map((x) => String(x).trim()).filter(Boolean);
                return cleaned.length ? cleaned : null;
            }
            if (typeof value === 'string') {
                const s = value.trim();
                return s ? s : null;
            }
            return null;
        },
        hasHighlights() {
            if (!this.highlights)
                return false;
            if (Array.isArray(this.highlights))
                return this.highlights.length > 0;
            return this.hasText(this.highlights);
        },
        // ---- MAP DATA ----
        googleMapsEmbedApiKey() {
            return String(process.env.VUE_APP_GOOGLE_MAPS_EMBED_API_KEY ?? '').trim();
        },
        mapLatitude() {
            return this.toCoordinate(this.productContent.latitude);
        },
        mapLongitude() {
            return this.toCoordinate(this.productContent.longitude);
        },
        mapAddress() {
            return this.readLocalizedText(this.productContent.address);
        },
        hasMapCoordinates() {
            return this.mapLatitude !== null && this.mapLongitude !== null;
        },
        hasMapData() {
            return this.hasMapCoordinates || this.hasText(this.mapAddress);
        },
        canEmbedMap() {
            return (this.hasText(this.googleMapsEmbedApiKey) &&
                this.hasMapCoordinates &&
                this.hasText(this.mapAddress));
        },
        googleMapsEmbedUrl() {
            if (!this.canEmbedMap)
                return '';
            const params = new URLSearchParams({
                key: this.googleMapsEmbedApiKey,
                q: this.mapAddress,
                center: `${this.mapLatitude},${this.mapLongitude}`,
                zoom: '15',
                maptype: 'roadmap',
            });
            return `https://www.google.com/maps/embed/v1/place?${params.toString()}`;
        },
        externalGoogleMapsUrl() {
            if (!this.hasMapData)
                return '';
            const query = this.hasText(this.mapAddress)
                ? this.mapAddress
                : `${this.mapLatitude},${this.mapLongitude}`;
            const params = new URLSearchParams({
                api: '1',
                query,
            });
            return `https://www.google.com/maps/search/?${params.toString()}`;
        },
    },
    methods: {
        hasText(val) {
            return typeof val === 'string' && val.trim().length > 0;
        },
        readLocalizedText(val) {
            if (typeof val === 'string')
                return val.trim();
            if (val && typeof val === 'object') {
                const maybeLocalized = val;
                if (typeof maybeLocalized.en === 'string') {
                    return maybeLocalized.en.trim();
                }
            }
            return '';
        },
        toCoordinate(val) {
            const parsed = typeof val === 'number'
                ? val
                : typeof val === 'string'
                    ? Number(val.trim())
                    : NaN;
            if (!Number.isFinite(parsed))
                return null;
            return parsed;
        },
        nl2br(val) {
            if (val == null)
                return '';
            return String(val).replace(/\r\n|\n/g, '<br>');
        },
    },
});
